import { render, staticRenderFns } from "./InviteesList.vue?vue&type=template&id=337d418c&"
import script from "./InviteesList.vue?vue&type=script&lang=js&"
export * from "./InviteesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports